import React, { FC, Fragment } from 'react';
import { InputAdornment, TableCell, TableRow } from '@mui/material';
import { PriceListMaterial } from 'models/material';
import { formatCurrency, formatDate } from 'utils/format';
import MonetaryValueInput from 'components/monetary-value/monetary-value.component';

type MaterialItemProps = {
    material: PriceListMaterial;
    onDiscountedPriceChange: (materialDiscountedPrice: { id?: string; discountedPrice: string }) => void;
    currency: string;
};

const MaterialItem: FC<MaterialItemProps> = ({ material, onDiscountedPriceChange, currency }: MaterialItemProps) => {
    const handleDiscountedPriceChange = (discountedPrice: string) => {
        onDiscountedPriceChange({ id: material._id, discountedPrice: discountedPrice });
    };

    return (
        <Fragment>
            {!material.inactive ? (
                <TableRow hover sx={{ cursor: 'pointer' }}>
                    <TableCell>{material.materialCode}</TableCell>
                    <TableCell>{material.description}</TableCell>
                    <TableCell>
                        {material.addedDate ? formatDate(new Date(parseInt(material.addedDate)), 'date') : '-'}
                    </TableCell>
                    <TableCell>{formatCurrency(parseFloat(material.basePrice || '0'), currency)}</TableCell>
                    <TableCell align="right">
                        <MonetaryValueInput
                            value={material.discountedPrice}
                            allowEmpty={true}
                            onValueChange={handleDiscountedPriceChange}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{currency}</InputAdornment>,
                            }}
                        />
                    </TableCell>
                </TableRow>
            ) : undefined}
        </Fragment>
    );
};

export default MaterialItem;
